define(["require", "exports", "jquery", "tablesorter/dist/js/jquery.tablesorter.js"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // initialize tablesorter
    var tableSorterTables = $('table.tablesorter');
    tableSorterTables.find('thead').attr('title', TYPO3.lang.tablesorter_shift_key_hint);
    var tableSorterOptions = {
        sortLocaleCompare: true,
        ignoreCase: true,
    };
    tableSorterTables.tablesorter(tableSorterOptions);
});
